import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Standardized error handling
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          // Unauthorized: Clear token and redirect
          localStorage.removeItem('token');
          // If on admin path, go to admin login, otherwise regular login
          if (window.location.pathname.startsWith('/admin')) {
            window.location.href = '/admin/login';
          } else {
            window.location.href = '/login';
          }
          break;
        case 403:
          console.error("Access Forbidden:", data.message || "You do not have permission to perform this action.");
          break;
        case 404:
          console.error("Resource Not Found:", data.message || "The requested resource was not found.");
          break;
        case 500:
          console.error("Server Error:", data.message || "Internal Server Error. Please try again later.");
          break;
        default:
          console.error(`API Error (${status}):`, data.message || error.message);
      }
    } else if (error.request) {
      console.error("Network Error: No response received from server.", error.request);
    } else {
      console.error("Request Configuration Error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
